export enum GreetingFilter {
  Any = 'any',
}
